import { createValueAndHalfValue } from '../../createValueAndHalfValue';

const createPopoverTokens = () => {
  const spaces = createValueAndHalfValue({
    expanded: 9.314,
    compact: 9.314,
    tiny: 9.314,
    small: 9.314,
    medium: 9.314,
    large: 9.314,
  });
  return {
    space: {
      ...spaces,
      arrow: {
        ...spaces,
      },
    },
    sizes: {
      tiny: '100px',
      small: '180px',
      medium: '400px',
      large: '600px',
      arrow: {
        ...spaces,
      },
    },
  };
};

export default createPopoverTokens;
